var angular = require('angular');
var _module = angular.module('angular-slick.sync', []);

require('jquery.easing');


/*
Syncs up your thumbnails with angular slick by scrolling to the current image
whenever the index changes.
 */

_module.directive('slickSync', [
    function() {
        return {
            restrict: 'A',
            link: function($scope, elem, attrs) {
                $scope.$watch(attrs.slickSync, function(value) {
                    if(!isNaN(value)) {
                        var targetChild = angular.element(elem.children()[value]);
                        var childsPosition = getOffsetX(value);
                        var centerOffset = (elem.outerWidth(true) / 2) - targetChild.outerWidth(true);
                        var maxScroll = getTotalWidth();
                        var scrollAmout = childsPosition - centerOffset;

                        if(scrollAmout > maxScroll) scrollAmout = maxScroll;
                        if(scrollAmout < 0) scrollAmout = 0;

                        elem.animate({ scrollLeft: scrollAmout }, 400, 'easeOutCubic');
                    }
                });

                function getTotalWidth() {
                    var totalWidth = 0;

                    elem.children().each(function() {
                        totalWidth += $(this).outerWidth(true);
                    });

                    return totalWidth;
                }

                function getOffsetX(childIndex) {
                    var totalOffsetX = 0;
                    var children = elem.children();

                    for(var i=0; i<childIndex; i++) {
                        totalOffsetX += angular.element(children[i]).outerWidth(true);
                    }

                    return totalOffsetX;
                }
            }
        };
    }
]);
